import { SettingsService } from "@nt-portal/server-sdk";
import { BaseClientService } from "../base-client.service";

export class ClientSettingsService extends BaseClientService {

    private _service: SettingsService;


    constructor() {
        super();
        this._service = new SettingsService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async msConfig() {
        return await this._service.msConfig(this.token);
    }

    public async oryConfig() {
        return await this._service.oryConfig(this.token);
    }

    public async metaData() {
        return await this._service.metaData(this.token);
    }

    public async loginConfig() {
        return await this._service.loginConfig(this.token)
    }
}